import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useUIContext } from "../../../../context/UIContext";
import SpecialSubjectContentTable from "./SpecialSubjectContentTable";

export default function SpecialSubjectContent({
  creUpdateLesson,
  setCreUpdateLesson,
  onClose,
}) {
  const { t } = useTranslation();
  const { handleToastCenterTop } = useUIContext();

  // 전체 데이터를 하나의 배열로 관리
  const [items, setItems] = useState([]);

  // Drawer가 열릴 때 기존 데이터 로드
  useEffect(() => {
    const existingData =
      creUpdateLesson?.extra_attributes?.specialSubjectContent;

    // 배열인지 확인하고, 아니면 빈 배열로 설정
    if (Array.isArray(existingData)) {
      setItems(existingData);
    } else {
      setItems([]);
    }
  }, [creUpdateLesson?.extra_attributes?.specialSubjectContent]);

  // 저장
  const handleSave = () => {
    // children 속성 제거하고 저장
    const cleanedItems = items.map(({ children, ...item }) => item);

    setCreUpdateLesson((prev) => ({
      ...prev,
      extra_attributes: {
        ...prev.extra_attributes,
        specialSubjectContent: cleanedItems,
      },
    }));

    handleToastCenterTop(
      t("teacher.lessonRelated.temporarySaveMessage") ||
        "임시 저장되었습니다. 수업에서 저장하기를 눌러 최종 저장하세요.",
    );
    onClose();
  };

  return (
    <>
      {/* 백드롭 */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.3)",
          zIndex: 999,
        }}
        onClick={onClose}
      />

      {/* Drawer 패널 */}
      <div
        style={{
          position: "fixed",
          right: 0,
          top: 0,
          width: "900px",
          height: "100vh",
          backgroundColor: "white",
          boxShadow: "-4px 0 15px rgba(0, 0, 0, 0.2)",
          zIndex: 1040,
          overflowY: "auto",
          animation: "slideIn 0.3s ease-out",
        }}
      >
        <div style={{ padding: "20px" }}>
          {/* 헤더 */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h4>
              {t("teacher.lessonRelated.specialSubjectContent") ||
                "배움내용 설정"}
            </h4>
            <button className="btn btn-secondary" onClick={onClose}>
              {t("common.labels.close") || "닫기"}
            </button>
          </div>

          {/* 테이블 컴포넌트 */}
          <SpecialSubjectContentTable items={items} setItems={setItems} />

          {/* 버튼 */}
          <div className="d-flex gap-2 justify-content-end mt-4">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
            >
              {t("common.labels.cancel") || "취소"}
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleSave}
            >
              {t("common.labels.temporarySave") || "임시 저장"}
            </button>
          </div>
        </div>
      </div>

      {/* CSS 애니메이션 */}
      <style>{`
        @keyframes slideIn {
          from {
            transform: translateX(100%);
          }
          to {
            transform: translateX(0);
          }
        }
      `}</style>
    </>
  );
}
